
export const FieldHelper = {

    FieldType: [
        { value: 1, name: "Email" },
        { value: 2, name: "Campo de texto" },
        { value: 3, name: "Texto" },
        { value: 4, name: "Lista de opções" },
        // { value: 5, name: "TypeAhead" },
        { value: 6, name: "Date" },
        { value: 7, name: "Moeda" },
        { value: 9, name: "Número" },
        { value: 10, name: "Nº Decimal" },
        { value: 12, name: "Boleano" },
      ],
      
      FieldTypeObj: {
        Email: 1,
        Area: 2,
        Text: 3,
        Select: 4,
        TypeAhead: 5,
        Date: 6,
        Currency: 7,
        Number: 9,
        Decimal: 10,
        Files: 11,
        Bool: 12,
        Password: 13,
        Mask: 14,
        Checkbox: 15,
        TextArea: 16,
        Time: 17,
      },
      
      ExtrairTexto: function(valor) {
        return valor
            .replace(/R\$/g, '')  // Remove "R$"
            .replace(/[0-9.,()]/g, '') // Remove números, pontos, vírgulas e parênteses
            .trim(); // Remove espaços extras no início e no fim
      },
    
      OnDataChange: function(oldData, evt, type) {
        let info = {};
        if (type === undefined) {
          info = { [evt.target.name]: evt.target.value };
        } else {
          if (type === this.FieldTypeObj.Currency || type === this.FieldTypeObj.Decimal) {
            info = { [evt.target.name]:  parseFloat(evt.target.value) === NaN ? 0 : parseFloat(evt.target.value) };
          } else if (type === this.FieldTypeObj.Area || type === this.FieldTypeObj.Text) {
            info = { [evt.target.name]: evt.target.value };
          } else if (type === this.FieldTypeObj.Number) {
            info = { [evt.target.name]: parseInt(evt.target.value) === NaN ? 0 : parseInt(evt.target.value) };
          } else if (type === this.FieldTypeObj.Files) {
            info = { [evt.target.name]: parseInt(evt.target.files) };
          } else if (type === this.FieldTypeObj.Bool) {
            info = {
              [evt.target.name]:
                evt.target.value === "true" || evt.target.value === true
                  ? true
                  : false,
            };
          } else {
            info = { [evt.target.name]: evt.target.value };
          }
        }
        return { ...oldData, ...info };
      }
      
}